export const useLanguage = (): string => {
    const paths = window.location.pathname.split('/');

    //Extract language from url path。 eg：'/hk/en/ramp'，'/en/ramp'
    return paths.length >= 3 ? paths[paths.length - 2] : '';
};
